import React, { useState } from "react";
import classes from "./TagInput.module.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getKeyGen } from "../../../../helpers";
import { faEye, faEyeSlash,faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const TagInput = ({
  autoComplete = "off",
  centerText = false,
  className = "",
  error = null,
  errorType = "",
  errors = null,
  forward_ref = null,
  label = null,
  maxLength = "",
  msgInfo = false,
  name = "",
  onChange = "",
  onBlur="",
  parentClass = null,
  placeholder = "",
  suggestedText = "",
  type = "text",
  value = "",
}) => {
  const { t } = useTranslation();
  const [isPasswodShow, setIsPasswodShow] = useState(false);
  let errorClass = classes.Error;
  const inputeCenterClass = centerText ? " " + classes.CenterText : "";
  const isPasswod = type === "password";
  let tempType = type;

  const keyPresed = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setIsPasswodShow(!isPasswodShow);
    }
  };

  if (isPasswodShow) tempType = "text";
  if (msgInfo) errorClass = classes.Error + " " + classes.MsgInfo;
  if (className) className = " " + className;

  let finalInput = (
    <div className={className}>
      {label && (
        <label className={classes.Label} htmlFor={"id_" + [name]}>
          {label}
        </label>
      )}
      <div className={classes.InputEyeArea}>
        <input
          className={(error && error)?(classes.TagErrorInput + inputeCenterClass+" "+({"":classes.BorderError,"warn":classes.BorderWarn,"error":classes.BorderError}[errorType])):classes.TagInput + inputeCenterClass}
          value={value}
          id={getKeyGen("id_" + name)}
          maxLength={maxLength}
          name={name}
          type={tempType}
          required={true}
          autoComplete={autoComplete}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          ref={forward_ref}
        />
        {isPasswod && (
          <FontAwesomeIcon
            onKeyDown={(e) => keyPresed(e)}
            tabIndex={"0"}
            title={
              isPasswodShow
                ? t("global.show_password")
                : t("global.hide_password")
            }
            onClick={() => setIsPasswodShow(!isPasswodShow)}
            icon={isPasswodShow ? faEye : faEyeSlash}
          />
        )}
      </div>
      {error && error !== "" && (
          {
            "": (<p className={errorClass}>{error}</p>),
            "error": (
              <div className={classes.errorDiv}>
                <FontAwesomeIcon className={classes.ButtonErrorSVG} icon={faExclamationTriangle} />
                {error}
                {suggestedText ?
                  (<><button onClick={() => { value = suggestedText; onChange({ target: { name, value } }); }} className={classes.ButtonError} type="button">{suggestedText}</button>?</>)
                  :
                  null
                }
              </div>
            ),
            "warn": (
              <div className={classes.warningDiv}>
                <FontAwesomeIcon className={classes.ButtonErrorSVG} icon={faExclamationTriangle} />
                {error}
                <button onClick={() => { value = suggestedText; onChange({ target: { name, value } }); }} className={classes.ButtonError} type="button">{suggestedText}</button>?
              </div>
            )
          }[errorType]
        )}

      {errors && errors[[name]] && errors[[name]].message !== "" && (
        <p className={errorClass}>{errors[[name]].message}</p>
      )}
    </div>
  );
  if (parentClass) {
    finalInput = <div className={parentClass}> {finalInput}</div>;
  }
  return finalInput;
};

export default TagInput;
